import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import DatePicker from 'react-date-picker';



import './AttendanceCamera.scss';
import MyContext from '../MyContext.jsx';
import CameraComponent from "./CameraComponent";

var customer_XHR={'abort' : ()=>{}};



class AttendanceCamera extends Component {

    constructor(props) {
      super(props);
      // this.remarksReq = React.createRef();

      this.state = {
        type : 'PRESENT',
        date : new Date(),
        from_date : '',
        to_date :'',
        no_of_days : '',
        reason:'',
        from_checked : false,
        to_checked : false,
        sid :'',
        address : null,
        status : 'IN',
        remarks:null,
        leavelist:[{
          id:'',
          from_date:'',
          to_date:'',
          no_of_days:'',
          reason:'',
          status:'',
        }],
        location : null,
        locationError: false,
        blob : null

      }
      this.formChange = this.formChange.bind(this);
      this.handleImageCapture = this.handleImageCapture.bind(this);

    }

    attendanceCheck(){
      var obj_this = this;
      const url2=`${process.env.REACT_APP_SSS}/api/getEmployeeAttendance`;
      var newdate=new Date();
      var year=newdate.getFullYear();
      var month=newdate.getMonth()+1;
      var day=newdate.getDate();
      var currdate=`${year}-${month}-${day}`
      $.ajax({
        url:url2,
        data:{
          sid:obj_this.context.user_details.sid,
          date:currdate,
        },
        type:"GET"
      }).done(function(return_data2){
        console.log(return_data2)
        if(return_data2.status=="Unmarked"){
          // obj_this.context.setAttendance(false);
          // alert("Please mark your attendance")
          obj_this.setState({
            status : return_data2.status
          });
        }else if(return_data2.status=="Present"){
          // obj_this.context.setAttendance(true);
          if(return_data2.attendance.status){
            obj_this.setState({
              status : return_data2.attendance.status
            });
          }
        }
      }).fail(function(){
        alert("Network Error");
        obj_this.props.history.replace('/');
      });
    }

    componentDidMount(){  
      // if(!this.context.attendance)
      this.attendanceCheck();

      var obj_this = this;
      
      var fetchLocation = function() {
        obj_this.setState({ locationError: false });
        obj_this.context.loading(1);
        
        if (typeof geo !== 'undefined') {
          geo.getLocation(function(location){
            if (location && location.latitude) {
              obj_this.context.setLocation(location);
              obj_this.context.loading(0);
              obj_this.setState({ location: location, locationError: false });
            } else {
              obj_this.context.loading(0);
              obj_this.setState({ locationError: true });
            }
          });
        } else {
          obj_this.context.loading(0);
          obj_this.setState({ locationError: true });
        }
      };

      fetchLocation();
      
      $(".location_button").off("click").on("click", fetchLocation);
      const data = new FormData();
      data.append('sid',this.context.user_details.sid);
      const url2 = `${process.env.REACT_APP_SSS}/api/getEmployeeLeaveRequestDetails`;
      var obj_this=this;
      var result2='';
      axios.post(url2,data)
      .then(res2 =>{
        // console.log(res.data);
        if(res2.data.status == "Leave Request Fetched"){
          result2=res2.data.leave;
          // console.log(result2);
          for(var i=0;i<result2.length;i++){
            var id = result2[i]['id'];
            var from_date = result2[i]['from_date'];
            var to_date = result2[i]['to_date'];
            var no_of_days=result2[i]['no_of_days'];
            // var leave_type=result2[i]['leave_type'];
            var reason=result2[i]['reason']
            var status = result2[i]['status'];
            obj_this.state.leavelist.push({ id, from_date,to_date,no_of_days,reason,status})
          }
          obj_this.state.leavelist.splice(0, 1);
          obj_this.context.loading(0);
          // console.log(obj_this.state.leavelist);

        }
        else{
          alert('Fetch failed');
        }
      });
      
    }

    handleImageCapture = (imageURI) => {
      var obj_this = this;
      if (imageURI.startsWith('file://')) {
        window.resolveLocalFileSystemURL(
            imageURI,
            function(fileEntry) {
                fileEntry.file(
                    function(file) {            
                        const reader = new FileReader();
                        reader.onloadend = function() {
                            const blob = new Blob([new Uint8Array(this.result)], { type: file.type });
                            console.log(blob)
                            obj_this.setState({
                              blob: blob,
                            });
                        };
                        reader.readAsArrayBuffer(file);
                    },
                    function(error) {
                        console.error('Error reading file:', error);
                    }
                );
            },
            function(error) {
                console.error('Error resolving file URL:', error);
            }
        );
      } else if (imageURI.startsWith('data:image')) {
        fetch(imageURI)
          .then(res => res.blob())
          .then(blob => {
            obj_this.setState({
              blob: blob,
            });
          })
          .catch(err => console.error('Error converting data URI to blob:', err));
      } else {
          console.error('Invalid image URI:', imageURI);
      }
    }


    formChange(e){
      this.setState({
        [e.target.name] : e.target.value
      });

      // console.log(this.state);
    }

    typeChange(e){
      this.setState({
        type : e.target.value
      });
    } 
    
    onDateChange(value){
      if(value!=null){
      this.setState({date : value});
      // console.log(value);
      }
    }

    onFromChange(value) {
      this.setState({ no_of_days: 0 });

      if (value != null) {
          this.setState({ from_date: value });
          const date1 = new Date(value);
          const date2 = new Date(this.state.to_date);

          let days = Math.abs(date2 - date1) / (1000 * 60 * 60 * 24) + 1;

          if (days === 0 && this.state.to_date) {
              days = 1;
          }

          this.getHalfDay(days);
      }
  }

  onToChange(value) {
      this.setState({ no_of_days: 0 });

      if (value != null) {
          this.setState({ to_date: value });
          const date1 = new Date(this.state.from_date);
          const date2 = new Date(value);

          let days = Math.abs(date2 - date1) / (1000 * 60 * 60 * 24) + 1;

          if (days === 0 && this.state.from_date) {
              days = 1;
          }

          this.getHalfDay(days);
      }
  }

  calculateDays(date1, date2) {
      if (date1 && date2) {
          if (date1.getTime() === date2.getTime()) {
              // this.setState({ no_of_days: 1 });
              this.getHalfDay(1);
              return;
          }

          const timeDiff = Math.abs(date2 - date1);
          let days = timeDiff / (1000 * 60 * 60 * 24) + 1;
          this.getHalfDay(days);
      }
  }

  getHalfDay(d) {
      let h1 = document.querySelector('.from').checked;
      let h2 = document.querySelector('.to').checked;

      if (h1) {
          d -= 0.5;
      }
      if (h2) {
          d -= 0.5;
      }

      if (isNaN(d)) {
          d = 0;
      }

      this.setState({
          no_of_days: d
      });
  }

  fromHalfDay = (e) => {
      const checked = e.target.checked;
      if (checked) {
          if (this.state.no_of_days === 0) {
              this.setState({
                  no_of_days: 0.5,
                  to_date: new Date()
              });
          } else {
              this.calculateDays(new Date(this.state.from_date), new Date(this.state.to_date));
          }
      } else {
          this.calculateDays(new Date(this.state.from_date), new Date(this.state.to_date));
      }
  };

  toHalfDay = (e) => {
      const checked = e.target.checked;
      if (checked) {
          if (this.state.no_of_days === 0) {
              this.setState({
                  no_of_days: 0.5,
              });
          } else {
              this.calculateDays(new Date(this.state.from_date), new Date(this.state.to_date));
          }
      } else {
          this.calculateDays(new Date(this.state.from_date), new Date(this.state.to_date));
      }
  };
    
    

    formSubmit(e){

      e.preventDefault();
      if(this.state.type=='PRESENT'){
        if(!this.state.location || !this.state.location.latitude){
          if (this.state.locationError) {
              alert("Unable to get location. Please check your GPS permission and try again.");
              $(".location_button").click();
          } else {
              alert("Please wait while we fetch your current location...");
          }
          return;
        }
        if(!this.state.blob){
          alert("No image. Please Mark Attendance again");
          this.props.history.replace('/dashboard');
          return;
        }
        // if(this.state.status == "Unmarked"){
        //   if(!this.state.remarks){
        //     this.remarksReq.current.focus();
        //     return;
        //   }
        // }
        if(this.state.status=="OUT"){
          if(!confirm("Are you sure you want to Checkout again?")){
            return;
          }
        }
        
      }
    

      this.context.loading(1);

      var sid =  this.context.user_details.sid;
      var fd = new FormData(document.querySelector('form'));

      fd.append('sid',sid);

      if (this.state.type == "PRESENT") {

        fd.append('latitude', this.state.location?.latitude);

        fd.append('longitude', this.state.location?.longitude);

        fd.append('image', this.state.blob);

      }

      // fd.append('address',this.state.address);


      const url = `${process.env.REACT_APP_SSS}/api/save/employee/attendance/leave/details`;
      var obj_this = this;

      axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "Attendance"){
          alert("Attendance added.");
          obj_this.context.loading(0);
          // obj_this.context.setAttendance(true);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "CheckIn"){
          alert("Checked In.");
          obj_this.context.loading(0);
          // obj_this.context.setAttendance(true);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "Checkout"){
          alert("Checked Out.");
          obj_this.context.loading(0);
          // obj_this.context.setAttendance(true);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "Leave"){
          alert("Leave request added successfully.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else {
          alert("Please Try Again");
          obj_this.props.history.replace('/');
          obj_this.context.loading(0);
        }
      });
    }   
     

  render(){

  return (

    <MyContext.Consumer>
      {context => (
        <div className="attendance_container_camera">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Mark Attendance</div>
          </div> 
          <form className="dealer_form"
            onSubmit={e => this.formSubmit(e)} encType="multipart/form-data" 
          >
            <div className="product_details_container blocks">

              <div className="input_label_head">{this.state.type == "PRESENT"?"Attendance Details":"Leave Details"}</div>
              <div className="input_radio_container">
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                        <input type="radio" 
                          name="type" 
                          value="PRESENT"  
                          checked={this.state.type == 'PRESENT'} 
                          onChange={e => this.typeChange(e)}
                        />
                        <div>PRESENT</div>
                      </div>
                      <div className="label_radio_container">
                        <input type="radio" 
                          name="type" 
                          value="LEAVE"
                          checked={this.state.type == 'LEAVE'} 
                          onChange={e => this.typeChange(e)}
                        />
                        <div>LEAVE</div>
                      </div>
                    </div>
                </div>
                <div style={{display:this.state.type == "LEAVE"?"none":"block"}}>
   
                  <div className="input_label">Date *</div>
                <DatePicker
                  className="input custom_input transaction_date"
                  name="date"
                  onChange={(value) => this.onDateChange(value)}
                  value={this.state.date}
                  format="dd-MM-y"
                  minDate={new Date()}
                  maxDate = {new Date()}
                  required={this.state.type=="PRESENT"}
                  clearIcon={null}
                /> 
                <CameraComponent onImageCapture={this.handleImageCapture}/>
                 <div className="input_label">Location Coordinates</div>
                <div className="location_container">
                  <input className=" location complaint input custom_input"
                    type="text"
                    name="location"
                    value={(this.state.location?.latitude)?this.state.location.latitude+", "+this.state.location.longitude:"Enable GPS Permission"}
                    onChange={this.formChange}
                    autoComplete="off"
                    disabled
                    required
                  />
                  <div className="location_button">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                </div>
                {/* <div>
                  <div className="input_label">Current Address</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "address"
                      value = {this.state.address}
                      onChange = {this.formChange}
                      disabled
                      required
                    />
                  </div>
                </div> */}
                <div>
                  <div className="input_label">Current Status</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "address"
                      value = {this.state.status}
                      onChange = {this.formChange}
                      disabled
                      required
                    />
                  </div>
                </div>
                <div style={{display:this.state.status=="Unmarked"?"block":"none"}}>
                  <div className="input_label">Remarks</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "remarks"
                      value = {this.state.remarks}
                      onChange = {this.formChange}
                      // ref={this.remarksReq}
                    // required = {this.state.status=="Unmarked"}
                    />
                  </div>
                </div>


              </div>
              <div style={{ display: this.state.type == "LEAVE" ? "block" : "none" }}>
                <div className="input_label">From Date *</div>
                <DatePicker
                  className="input custom_input_date transaction_date"
                  name="from_date"
                  onChange={(value) => this.onFromChange(value)}
                  value={this.state.from_date}
                  minDate={new Date(new Date().toDateString())}
                  format="dd-MM-y"
                  required={this.state.type === "LEAVE" ? true : false}
                  clearIcon={null}
                />
                <input
                  type="checkbox"
                  className="from"
                  name=""
                  value=""
                  onClick={e => this.fromHalfDay(e)}
                />
                <span className="input_label">Half Day </span>

                <div className="input_label">To Date *</div>
                <DatePicker
                  className="input custom_input_date transaction_date"
                  name="to_date"
                  disabled={!this.state.from_date}
                  onChange={(value) => this.onToChange(value)}
                  value={this.state.to_date}
                  minDate={this.state.from_date}
                  format="dd-MM-y"
                  required={this.state.type === "LEAVE" && this.state.from_date ? true : false}
                  clearIcon={null}
                />
                <input
                  type="checkbox"
                  className="to"
                  name=""
                  value=""
                  onClick={e => this.toHalfDay(e)}
                />
                <span className="input_label">Half Day </span>

                <div className="input_label">Total Days *</div>
                <input
                  className="name input custom_input"
                  type="number"
                  name="no_of_days"
                  value={this.state.no_of_days}
                  onChange={this.formChange}
                  required={this.state.type === "LEAVE" ? true : false}
                  autoComplete="off"
                />

                <div className="input_label">Reason *</div>
                <textarea className="input billing_address custom_input"
                  name="reason"
                  value={this.state.reason}
                  onChange={this.formChange}
                  required={this.state.type == "LEAVE"}
                  autoComplete="off"
                />
              </div>
            </div>

              <button type="submit" className="submit_button"><i className="far fa-save"></i> {this.state.type =="PRESENT"?this.state.status=="Unmarked"?"Punch In":this.state.status=="IN"?"Punch Out":"Punched out Successfully":"Save"}</button>
            </form>   

            <div className="list_blocks_container" style={{display:this.state.type=="LEAVE"?"block":"none"}}>
              <div className="lists_container">
                {this.state.leavelist.map((item,idx)=>(
                  <div className="single_collection_container" key={idx}>
                    <div className="collection_customer_name_delete_button_container">
                    <div className="leave2_details_status_button">
                        <div className="collection_customer_name"># Days : {item.no_of_days}</div>
                        <div className="leave_status_requested" style={{display:item.status=="REQ"?"block":"none"}}><i className="fa fa-clock" aria-hidden="true"></i> REQUESTED</div>
                        <div className="leave_status_approved" style={{display:item.status=="APR"?"block":"none"}}> <i className="fa fa-check" aria-hidden="true"></i>APPROVED</div>
                        <div className="leave_status_rejected" style={{display:item.status=="CNL"?"block":"none"}}> <i className="fa fa-times" aria-hidden="true"></i>REJECTED</div>
                      </div>
                      <div className="leave_details_status_button_container">
                        <div className="leave_date"><i className="fa fa-calendar-alt"></i> {new Date(item.from_date).toLocaleDateString('en-GB')}</div>
                        <div className="divider">---</div>
                        <div className="leave_date"><i className="fa fa-calendar-alt"></i> {new Date(item.to_date).toLocaleDateString('en-GB')}</div>
                      </div>
                      {/* <div className="leave_type">Leave Type : {item.leave_type}</div> */}
                      <div className="leave2_reason">Reason : {item.reason}</div>
                    </div>
                  </div>

                ))}
              </div>
            </div>             
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default AttendanceCamera;
AttendanceCamera.contextType = MyContext;
